import { formatDateTime } from '_metronic/helpers'

/** Traço usado quando o campo não tem valor — nunca renderizar "null"/"undefined" na tela. */
export const VAZIO = '—'

/**
 * `LocalDate` (`YYYY-MM-DD`) → `DD/MM/AAAA`, sem passar por `new Date`.
 *
 * `new Date('2026-08-01')` é interpretado como UTC e, no fuso do Brasil, volta um dia — a data do
 * atendimento apareceria errada na listagem e não bateria com o filtro de período.
 */
export const formatarData = (valor?: string | null): string => {
  if (!valor) return VAZIO
  const partes = valor.slice(0, 10).split('-')
  if (partes.length !== 3) return valor
  const [ano, mes, dia] = partes
  return `${dia}/${mes}/${ano}`
}

/** `LocalDateTime` → `DD/MM/AAAA HH:mm`, com traço quando nulo (envio ainda não transmitido). */
export const formatarDataHora = (valor?: string | null): string => {
  if (!valor) return VAZIO
  const formatado = formatDateTime(valor)
  return formatado === '-' ? VAZIO : formatado
}
